import { render, staticRenderFns } from "./CollectConsent.vue?vue&type=template&id=7d4b8c8f&scoped=true"
import script from "./CollectConsent.vue?vue&type=script&lang=js"
export * from "./CollectConsent.vue?vue&type=script&lang=js"
import style0 from "./CollectConsent.vue?vue&type=style&index=0&id=7d4b8c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b8c8f",
  null
  
)

export default component.exports